// extracted by mini-css-extract-plugin
module.exports = {"progress":"ChangeTrendIntervalModal_progress__3bpRD","circularProgress":"ChangeTrendIntervalModal_circularProgress__3LUlS","form":"ChangeTrendIntervalModal_form__1aO77"};